import { CoreIcon } from '../core-icon';
import closeSVG from '../../assets/icons/close.svg';
import type { IconProps } from '../core-icon';

export const CloseIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={closeSVG} {...props} />;
};
